
const clamp = (low: number, high: number, n: number) =>
    Math.max(low, Math.min(high, n));

export default clamp;

export {
    clamp,
};
